import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { MauCount } from '../../../../../../shared/types';
import type { Action } from 'redux';

const FetchMauCountData = new ReduxAsyncAction<'FETCH_MAU_COUNT_DATA', void, MauCount>('FETCH_MAU_COUNT_DATA');

FetchMauCountData.registerRequest(async () => {
  const URI = '/v1/usage/mau/count-data';

  try {
    const countData = await dash_api.get<MauCount>(URI);

    return countData?.data;
  } catch (e) {
    throw e;
  }
});

export const FETCH_MAU_COUNT_DATA = FetchMauCountData.actionNamespaceConstants;

export const fetchMauCountData = FetchMauCountData.request;

export type FetchMauCountDataResponseAction = Action<typeof FETCH_MAU_COUNT_DATA.response> & { data: MauCount };
